export default __webpack_public_path__ + "static/media/vn.a3c28627.svg";